import { validateEmail } from '@/common/const/validators.const'
import { mapActions, mapGetters } from 'vuex'
const FORM_REF = 'loginForm'
export default {
  data () {
    const RULES = {
      email: [
        { required: true, message: this.$t('validation.fieldRequired'), trigger: 'blur' },
        { validator: validateEmail, message: this.$t('validation.emailNotValid'), trigger: 'blur' }
      ],
      password: [
        { required: true, message: this.$t('validation.fieldRequired'), trigger: 'blur' }
      ]
    }
    return {
      showProcessError: false,
      form: {
        email: null,
        password: null
      },
      rules: RULES,
      // eslint-disable-next-line no-undef
      formRef: FORM_REF
    }
  },
  computed: {
    ...mapGetters({
      isLoading: 'isUserProcessing'
    })
  },
  methods: {
    ...mapActions([
      'doUserLogin',
      'getUserSession'
    ]),
    goToHomePage () {
      this.$router.push({ name: 'home' })
    },
    goToRemindPassword () {
      this.$router.push({ name: 'remindPassword' })
    },
    goToRegister () {
      this.$router.push({ name: 'register' })
    },
    getForm () {
      return this.$refs[FORM_REF]
    },
    submit () {
      this.showProcessError = false
      this.getForm().validate((valid) => {
        if (!valid) {
          return false
        }

        this.doUserLogin(this.form)
          .then(this.getUserSession)
          .then(this.goToHomePage)
          .catch(() => {
            this.showProcessError = true
          })
      })
    }
  }
}
